<div *ngIf="place">

  <!-- Gallery (hidden) -->
  <div class="section-gallery">
    <div id="gallery" class="pswp-gallery pswp-gallery--single-column">
      <a *ngFor="let image of images"
         [href]="image.filePath"
         [attr.data-pswp-src]="image.filePath"
         [attr.data-pswp-width]="image.width || 1024"
         [attr.data-pswp-height]="image.height || 682">
      </a>
    </div>
  </div>

  <!-- Pending Place -->
  <div class="section-pending-place">
    <!--  <app-pending-place *ngIf="place.isPending" [place]="place"></app-pending-place>-->
  </div>

  <!-- Hero -->
  <div class="section-hero" (click)="showGallery(0)">
    <div class="top-fold" [style]="{'background-image': 'url(&quot;' + ((place.largeImages && place.largeImages.length > 0) ? place!.largeImages![0].filePath : '/images/discover/place-detail/place-default.webp') + '&quot;)'}">

      <div class="overlay">

        <!-- Back button -->
        <div class="overlay-left">
          <a routerLink="{{ previousPath }}" queryParamsHandling="preserve" class="btn btn-default btn-back" (click)="$event.stopPropagation()">
            <i class="bi bi-chevron-left ps-1 pe-1"></i>
          </a>
        </div>

        <!-- Heart -->
        <div class="overlay-right">
          <div class="heart" *ngIf="currentUser"
               [ngClass]="{ 'heart-on': place!.likes!.indexOf(currentUser._id!) >= 0, 'heart-off': place!.likes!.indexOf(currentUser._id!) == -1}"
               (click)="toggleLike(); $event.preventDefault(); $event.stopPropagation();"></div>
        </div>

      </div>
    </div>
  </div>

  <br/>

  <!-- Title & Location -->
  <div class="section-title" *ngIf="region && place">
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h2 class="name">{{ place.name }}</h2>
          <p class="neighborhood" *ngIf="place.location">
            <span *ngIf="regionSlug && neighborhoodSlug"><a [routerLink]="['/discover', regionSlug, neighborhoodSlug]">{{ place.location!.neighborhood }}</a></span>
            <span *ngIf="regionSlug && neighborhoodSlug">&nbsp;•&nbsp;</span>
            <span *ngIf="regionSlug"><a [routerLink]="['/discover', regionSlug]">{{ region!.name }}</a></span>
          </p>
          <p class="neighborhood" *ngIf="place && place.location">
            <a [href]="place.useCoordinates
                ? ('https://maps.google.com/?q=' + place.location.latitude + ',' + place.location.longitude)
                : ('https://maps.google.com/?q=' + place.location.address + ', ' + place.location.city + ', ' + place.location.state + ' ' + place.location.zipcode)"
               target="_blank" rel="noopener nofollow noreferrer">
              <span *ngIf="place && place.location">{{ place.location.address }}, </span>
              <span *ngIf="place && place.location && place.location.address2">{{ place.location.address2 }}, </span>
              <span *ngIf="place && place.location">{{ place.location.city }}, </span>
              <span *ngIf="place && place.location">{{ place.location.state }} </span>
              <span *ngIf="place && place.location">{{ place.location.zipcode }}</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>

  <br/>

  <!-- Availability -->
  <div class="section-availability">
    <div class="container g-5">
      <div class="availability-box">
        <div class="row">

          <!-- Seat availability -->
          <div class="col-12">
            <div class="text-center">
              <div>
                <span class="available-seats-dot"><i [ngClass]="{disabled: currentUser && (!place!.visible || place!.availableSeats!.length == 0 || !(currentUser ? (currentUser.verification ? place!.isVerifiedOpen : place!.isOpen) : place!.isOpen))}"></i></span>
                <span class="available-seats-text" *ngIf="!place!.visible">Not available</span>
                <span class="available-seats-text" *ngIf="place!.visible">{{ place.availableSeats!.length }} seat{{ place.availableSeats!.length == 1 ? '' : 's' }} available</span>
              </div>

              <p class="gray" style="margin: 4px;">(You have {{ remaining }} {{ remainingUnit }} remaining)</p>
              <br/>
            </div>
          </div>

          <!-- Actions -->
          <div class="col-12">
            <div class="row">

              <!-- Check in button -->
              <div class="col-12 col-sm-6" *ngIf="!reserve">
                <button type="button" class="btn btn-block btn-lg checkin"
                        (click)="createVisit()"
                        [disabled]="currentUser && (isVisitSubmitted || isHoldSubmitted || isFutureHoldSubmitted || hasActiveVisit || hasActiveHold || (currentUser.verification && !place!.isVerifiedOpen) || (!currentUser!.verification && !place!.isOpen))"
                        style="font-size: 18px; width: 100%;">
                  <span>Check In</span>
                  <span *ngIf="isVisitSubmitted" class="spinner-border spinner-border-sm ms-2"></span>
                </button>
                <br/>
                <br class="hide-lg hide-xl hide-xxl"/>
              </div>

              <!-- Hold seat button -->
              <div class="col-12 col-sm-6" *ngIf="!reserve">
                <button type="button" class="btn btn-block btn-lg holdseat"
                        (click)="createHold()"
                        [disabled]="currentUser && (isVisitSubmitted || isHoldSubmitted || isFutureHoldSubmitted || hasActiveVisit || hasActiveHold)"
                        style="font-size: 18px; width: 100%;">
                  <span>Hold Seat</span>
                  <span *ngIf="isHoldSubmitted" class="spinner-border spinner-border-sm ms-2"></span>
                </button>
                <br/>
                <br class="hide-lg hide-xl hide-xxl"/>
              </div>

              <!-- Future hold seat button -->
              <div class="col-12 col-sm-12" *ngIf="reserve">
                <button type="button" class="btn btn-block btn-lg holdseat"
                        (click)="createFutureHold()"
                        [disabled]="currentUser && (isVisitSubmitted || isHoldSubmitted || isFutureHoldSubmitted || hasActiveVisit || hasActiveHold)"
                        style="font-size: 18px; width: 100%;">
                  <span>Reserve seats for {{ reserve | date: 'shortDate' }} at {{ reserve | date: 'shortTime' }}</span>
                  <span *ngIf="isHoldSubmitted" class="spinner-border spinner-border-sm ms-2"></span>
                </button>
                <br/>
                <br class="hide-lg hide-xl hide-xxl"/>
              </div>
            </div>
          </div>

          <!-- Activity -->
          <div class="col-12" *ngIf="activity && (hasActiveVisit || hasActiveHold)">
            <br/>
            <div class="text-center">
              <div *ngIf="hasActiveVisit && activity && activity.activeVisits.length > 0">
                <a routerLink="/activity">You're currently checked in at <span class="underline">{{ activity.activeVisits[0].place.name }}</span></a>
              </div>
              <div *ngIf="hasActiveHold && activity && activity.activeHolds.length > 0">
                <a routerLink="/activity">You're currently holding {{ activity.activeHolds[0].seats.length > 1 ? activity.activeHolds[0].seats.length + ' seats' : ' 1 seat' }} at <span class="underline">{{ activity.activeHolds[0].place.name }}</span></a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <br/>

  <!-- Images -->
  <div class="section-images" *ngIf="place!.mediumImages && place!.mediumImages!.length > 3">
    <div class="container g-5">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4" *ngIf="place!.mediumImages!.length > 1">
          <a (click)="showGallery(1)">
            <img [src]="place!.mediumImages![1].filePath" class="img-responsive" [alt]="place!.mediumImages![1].description"/>
          </a>
          <br/>
          <br/>
        </div>

        <div class="col-12 col-sm-4 col-md-4" *ngIf="place!.mediumImages!.length > 2">
          <a (click)="showGallery(2)">
            <img [src]="place!.mediumImages![2].filePath" class="img-responsive" [alt]="place!.mediumImages![2].description"/>
          </a>
          <br/>
          <br/>
        </div>

        <div class="col-12 col-sm-4 col-md-4" *ngIf="place!.mediumImages!.length > 3">
          <a (click)="showGallery(3)">
            <img [src]="place!.mediumImages![3].filePath" class="img-responsive" [alt]="place!.mediumImages![3].description"/>
          </a>
          <br/>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- Hours -->
  <div class="section-hours">
    <hr/>
    <br/>
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>Hours</h3>
          <app-place-detail-hours [place]="place!"></app-place-detail-hours>
        </div>
      </div>
    </div>
    <br/>
  </div>

  <!-- About -->
  <div class="section-hours">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>About</h3>
          <br/>

          <div *ngIf="place!.words">
            <p>
              <span *ngFor="let word of place!.words; let position = index">
                {{ word }}
                <span *ngIf="position + 1 < place!.words.length">&nbsp;&nbsp;•&nbsp;&nbsp;</span>
              </span>
            </p>
          </div>

          <div *ngIf="place!.description">
            <p class="description" [innerHTML]="place!.description | linkify"></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Amenities -->
  <div class="section-amenities">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>Amenities</h3>
          <br/>

          <div *ngIf="place!.amenities">
            <div class="row" *ngFor="let amenity of place!.amenities">
              <div class="col-12 col-md-3 col-lg-3 col-xl-2">
                <strong>{{ amenity.title }}</strong>
              </div>
              <div class="col-12 col-md-9 col-lg-9 col-xl-10">
                <p [innerHTML]="amenity.description! | linkify"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Important -->
  <div class="section-important">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>Need to know</h3>
          <br/>

          <!-- Seating -->
          <div class="row" *ngIf="place!.seating">
            <div class="col-12 col-md-3 col-lg-3 col-xl-2">
              <strong>Seating</strong>
            </div>

            <div class="col-12 col-md-9 col-lg-9 col-xl-10">
              <p [innerHTML]="place!.seating | linkify"></p>
            </div>
          </div>

          <!-- Important facts -->
          <div class="row" *ngIf="place!.importantFacts && place!.importantFacts.length > 0 && currentUser">
            <div class="col-12 col-md-3 col-lg-3 col-xl-2">
              <strong>Getting there</strong>
            </div>

            <div class="col-12 col-md-9 col-lg-9 col-xl-10">
              <p *ngFor="let importantFact of place!.importantFacts">
                &bull;<span style="display: inline; margin-left: 16px;" [innerHTML]="importantFact | linkify"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Conference rooms -->
  <div class="section-conference-rooms" *ngIf="rooms.length > 0">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col-12">
          <h3>Conference rooms</h3>
          <br/>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3" *ngFor="let room of rooms">
          <app-room-box [room]="room" [showPlaceNameAndNeighborhoodText]="false" [showCapacityAndPriceText]="true"/>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- Map (Mobile & Tablet) -->
  <div class="section-map hide-xl hide-xxl" *ngIf="place!.location!">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>Location</h3>
          <br/>

          <a target="_blank"
             href="{{ place!.useCoordinates
             ? ('https://maps.google.com/?q=' + place!.location!.latitude + ',' + place!.location!.longitude)
             : ('https://maps.google.com/?q=' + place!.location!.address + ', ' + place!.location!.city + ', ' + place!.location!.state + ' ' + place!.location!.zipcode)}}">
            <img class="img-responsive"
                 src="https://maps.googleapis.com/maps/api/staticmap?center={{ place!.location!.latitude }},{{ place!.location!.longitude }}&zoom=15&size=800x400&maptype=roadmap%20&markers=color:red%7Clabel:%26%238226%3B%7C{{ place!.location!.latitude }},{{ place!.location!.longitude }}&key={{ GOOGLE_MAP_API_KEY }}"
                 alt="Location Map"/>
          </a>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

  <!-- Join CTA -->
  <!-- need to be a component -->
  <!-- <div ng-include="'views/templates/subscribe-template.html'" *ngIf="!place?.isPending && !currentUser"></div> -->
</div>

<!-- Loading -->
<div class="container-fluid" *ngIf="loading">
  <div class="text-center">
    <br/>
    <br/>
    <span class="spinner-border"></span>
    <br/>
    <br/>
  </div>
</div>
